import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=45d82600&"
import script from "./BookingCard.vue?vue&type=script&lang=js&"
export * from "./BookingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports